import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Auth = (WrappedComponent, Roles) => {
  const AuthCheck = (props) => {
    const navigate = useNavigate();
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
      let collectData = [];
      let user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        const userRole = user.role;
        collectData = Roles.filter((data) => userRole === data);
        if (collectData.length) {
          setIsAuthorized(true);
        }
      } else {
        navigate("/login");
      }
    }, [navigate]);

    if (isAuthorized) {
      return <WrappedComponent {...props} navigate={navigate} />;
    } else {
      return <div>YOU ARE NOT AUTHORIZED TO USE THE PAGE</div>;
    }
  };
  return AuthCheck;
};

export { Auth };
